<template>
    <div class="CenteredContent">
        <h1 class="title">Let’s create an account</h1>
        <h5 class="intro"> You will be able to sign in with your email address and password </h5>
        <div class="inputContainer">
            <a-form :form="form" layout="horizontal">
                <a-form-item label="Email">
                    <a-input type="email" size="large" placeholder="Input your email please" v-decorator="[
                        'email',
                        {
                            rules: [
                                {
                                    required: true,
                                    type: 'email',
                                    message: 'Your email is invalid',
                                },
                            ],
                        },
                    ]"></a-input>
                </a-form-item>
                <a-form-item label="Password (must more than 6 letters)">
                    <a-input-password @change="handlePwd" size="large" placeholder="Input your password please" v-decorator="[
                        'password',
                        {
                            rules: [
                                {
                                    required: true,
                                    min: 6,
                                },
                            ],
                        },
                    ]"></a-input-password>
                </a-form-item>
                <a-form-item label="Confirm Password ">
                    <a-input-password size="large" placeholder="Input your password again" v-decorator="[
                        'confirmpassword',
                        {
                            rules: [
                                {
                                    required: true,
                                    validator: (_, value, cb) =>
                                        value === password
                                            ? cb()
                                            : cb('Passwords are not same'),
                                },
                            ],
                        },
                    ]"></a-input-password>
                </a-form-item>

                <a-form-item>
                    <a-button size="large" type="primary" html-type="submit" @click="handleNext">Next Step</a-button>
                </a-form-item>
            </a-form>
        </div>
    </div>
</template>

<script>

export default {

    props: ['handleCreate','default'],
    data() {
        return {
            form: this.$form.createForm(this, { name: 'account',props: this.default }),
            password: undefined
        };
    },
    methods: {
        handlePwd(val) {
            this.password = val.target.value;
        },
        async handleNext(e) {
            e.preventDefault()
            this.form.validateFields(async (err, values) => {
                if (!err) {
                    await this.handleCreate(values)
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.CenteredContent {
    padding: 6.25rem 5rem;
    justify-content: flex-start;
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;

    .title {
        font-style: normal;
        font-weight: 500;
        font-size: 30px;
        line-height: 40px;
        font-family: auto;
        text-align: center;
    }

    .intro {
        text-align: center;
    }

    .inputContainer {
        width: 100%;
        max-width: 500px;
        padding: 2rem 2rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
}
</style>